import lodash from 'lodash';
import { DataGrid } from 'common/components/DataGrid/DataGrid';
import { trackEvent } from 'components/common/GoogleAnalytics/GoogleAnalytics';

export const Recipient = ({ taskId, displayName, emailAddress, status, cancelTask }) => {
    const recipient = {
        taskId,
        displayName,
        emailAddress,
        status : lodash.lowerCase(status)
    };
    const userListGridFields = [{
        fieldKey: 'displayName',
        valueSelector: 'displayName',
        weight: 3,
        displayOrder: 1,
        header: 'Name'
    }, {
        fieldKey: 'emailAddress',
        valueSelector: 'emailAddress',
        weight: 3,
        displayOrder: 2,
        header: 'Email'
    }, {
        fieldKey: 'status',
        valueSelector: 'status',
        weight: 1,
        displayOrder: 3,
        header: 'Status'
    }, {
        fieldKey: 'cancelButton',
        valueSelector: recipient => null,
        contentTemplate: <CancelButton cancelTask={cancelTask} trackEvent={trackEventGoogleAnalytics} />,
        weight: 1,
        displayOrder: 4,
        header: 'Cancel',
        contentRowAlign: 'center',
        contentColumnAlign: 'center',
        headerRowAlign: 'center',
    }];

    return (
        <DataGrid
            data={[recipient]}
            fields={userListGridFields}
            showHeaders 
            data-cy="DataGrid"/>
    );
};

function trackEventGoogleAnalytics() {
    const category = 'event';
    const action = 'Cancel Event';
    trackEvent({category, action});
}

const CancelButton = ({ rawData, cancelTask, trackEvent }) => {
    const { taskId, status } = rawData;
    const visibility = status=== 'pending' ? 'visible' : 'hidden';
    const onClick = () => {
        trackEvent();
        cancelTask(taskId);
    };
    return <button type='button' style={{visibility}} onClick={onClick} data-cy="CancelButton-Cancel">Cancel</button>;
};

